import VideoPlayer from './utils/VideoPlayer';

interface Props {
  videoUrl: string;
  inactive?: boolean;
  onVideoStop?: () => void;
  onVideoPlay?: () => void;
}

const CarouselVideoSlide = (props: Props) => {
  return <VideoPlayer {...props} autoplay={true} />;
};

export default CarouselVideoSlide;
